export class EdicaoMascaras {

  id: number;
  descricao: string;

  constructor() {

  }

  // tipo:
  // 0 - Ambos
  // 1 - CPF
  // 2 - CNPJ
  static retornaMascaraCpfCnpj(cpfCnpj, tipo: number): string {
    if (tipo == 1) {
      return '000.000.000-00';
    }
    else {
      if (cpfCnpj && cpfCnpj.length <= 11 && tipo == 0)
        return 'AAA.AAA.AAA-AAA';
      else
        return 'AA.AAA.AAA/AAAA-00';
    }
  }

  static retornaMascaraTelefone(telefone) {

    if (telefone && telefone.replace(/[^0-9]/g, '').length <= 10) {
      return '(00) 0000-00009';
    }
    if (telefone && telefone.length > 10) {
      return '(00) 00000-0000';
    }
  }
}